import React from 'react';
import { Redirect } from 'react-router-dom';
import { isCredentialsExists } from 'utils/localData/credentials';
import { ROUTE_AUTH } from 'fixtures/routes';

export const shouldRedirect = (isProtected) => {
  if (isProtected) return !isCredentialsExists();
  return false;
};

export const getProtectedRoute = (route, props) => {
  const TagName = route.main
  return shouldRedirect(route.isProtected)
    ? (<Redirect to={`/${ROUTE_AUTH}`} />)
    : (<TagName {...props} />);
}